export default __webpack_public_path__ + "static/media/homeBackground.d6bbf00b.png";